<!-- 
  单笔话费充值
  lovi 2020-07-29
 -->
<template>
  <div class="recharge">
    <div class="step-wrap" v-if="!comboFlag">
      <div class="stepCon active">
        <p class="stepTxt">1.{{ $t("recharge.fillMobileNumberAmount") }}</p>
      </div>
      <div class="stepCon" :class="{ active: tabNum != 0 }">
        <div class="step active"></div>
        <p class="stepTxt">2.{{ $t("recharge.confirmPay") }}</p>
      </div>
      <div class="stepCon" :class="{ active: tabNum == 2 }">
        <div class="step" :class="{ active: tabNum != 0 }"></div>
        <p class="stepTxt">3.{{ $t("common.done") }}</p>
      </div>
    </div>
    <div class="step-content1" v-if="!comboFlag">
      <div class="tab1" v-show="tabNum == 0">
        <div class="global-dl first-step">
          <dl>
            <dt>{{ $t("recharge.rechargeNumber") }}：</dt>
            <dd>
              <Input
                v-model="phone"
                :placeholder="$t('common.enterMobile')"
                @on-blur="fieldFocus"
                @on-change="fieldInput"
              />
              <p class="text-red" v-if="operatorId == -1">
                {{ $t("recharge.phoneNumberError") }}
              </p>
              <p class="text-blue" v-else>{{ operatorName }}</p>
            </dd>
          </dl>
          <dl v-if="rechargeType == 0">
            <dt>{{ $t("wallet.rechargeAmount") }}：</dt>
            <dd>
              <money-list
                v-if="denomination.length"
                :money.sync="money"
                :moneyId.sync="moneyId"
                :list="denomination"
                :custom="operator_recharge"
                :rate="Number(curPay.exchange_rate)"
                :recently="recently"
              />
              <div v-else class="no-operator text-gray">
                {{ $t("recharge.operatorNotSupport") }}
              </div>
            </dd>
          </dl>
          <dl v-if="rechargeType == 1">
            <dt>{{ $t("recharge.selectPackage") }}：</dt>
            <dd>
              <div
                v-if="operatorState[operatorId] == 1"
                @click="clickCombo"
                class="choose-combo"
              >
                <div class="info" v-if="comboInfo.denomination_id">
                  <p>
                    {{ comboInfo.content }}
                  </p>
                  <span class="text-orange"> {{ comboInfo.amount }}P </span>
                </div>
                <div class="info default" v-else>
                  <p>{{ $t("recharge.dataChargeSelectPackage") }}</p>
                </div>
                <Icon type="ios-arrow-forward" />
              </div>
              <div v-else class="no-operator text-gray">
                {{ $t("recharge.operatorNotSupport") }}
              </div>
            </dd>
          </dl>

          <!-- 选择支付方式 -->
          <pay-list
            :money.sync="money"
            :showDiscount="rechargeType == 0 ? true : false"
            @getCurPay="getCurPay"
          />
        </div>
        <div class="button-wrap">
          <Button type="primary" long @click="nextStep">
            {{ $t("common.nextStep") }}
          </Button>
        </div>
      </div>
      <div v-if="tabNum == 1" class="tab2">
        <div class="sweep-code">
          <p>
            {{
              rechargeType == 1
                ? $t("recharge.dataTrafficRecharge")
                : $t("recharge.phoneFeeRecharge")
            }}
          </p>
          <div class="password" v-if="curPay.payment_id == 3">
            <h5>{{ money.toFixed(2) }}P</h5>
            <div class="inputPsd">
              <Input
                v-model="payPsd"
                type="password"
                password
                :placeholder="$t('common.enterPayPsd')"
              />
            </div>
            <div class="button-wrap">
              <Button type="primary" long @click="paycalls">
                {{ $t("common.confirm") }}
              </Button>
            </div>
          </div>
          <!-- 微信支付 -->
          <pay-code
            v-if="curPay.payment_id == 5"
            :money="money"
            :type="curPay.payment_id"
            :data="payMentInfo"
            @getPayCode="getPayCode"
          />
        </div>
      </div>
      <detail
        v-if="tabNum == 2"
        :order_id="payMentInfo.order_id"
        :type="rechargeType == 0 ? 5 : 6"
      />
    </div>

    <!-- 选择套餐 -->
    <combo
      v-if="comboFlag"
      :comboFlag.sync="comboFlag"
      :operatorId.sync="operatorId"
      @getComboInfo="getComboInfo"
    />
    <Modal
      v-model="selectComboFlag"
      title=""
      class-name="vertical-center-modal"
      width="400"
      :mask-closable="false"
    >
      <div class="modal-title">
        <h3>{{ $t("common.tips") }}</h3>
      </div>
      <div class="modal-container">
        <p>{{ $t("recharge.pleaseSelectOperator") }}</p>
      </div>
      <div slot="footer" class="footer" align="center">
        <Button @click="selectCombo">Smart</Button>
        <Button @click="selectCombo(1)">Tnt</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Detail from "@/components/detail";
import MoneyList from "@/components/recharge/moneyList";
import Combo from "@/components/recharge/combo";
import PayList from "@/components/payList";
import PayCode from "@/components/payCode";
export default {
  props: {
    rechargeType: {
      //当前选中的tab页
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  components: {
    Detail,
    MoneyList,
    Combo,
    PayList,
    PayCode
  },
  data() {
    return {
      tabNum: 0, //充值步骤下标
      phone: "", //手机号
      callInfo: {}, //充值信息
      operatorList: [], //运营商列表
      operatorName: "", //当前运营商名称
      operatorId: 0, //当前运营商类型标识
      operatorState: {}, //运营商支持流量套餐状态
      allMoney: {}, //全部金额面板
      denomination: [], //金额面板
      operator_recharge: {}, //自定义金额
      recently: "", // 最近充值金额
      money: 0, // 金额
      moneyId: 0, //话费金额Id
      comboFlag: false, //选择套餐
      comboInfo: {}, //套餐选择的信息
      selectComboFlag: false,
      payPsd: "",
      payMentInfo: {}, // 支付信息
      curPay: {} // 当前充值方式
    };
  },
  created() {
    this.getCalls();
    this.operatorDataPackageState();
    this.getCallsDenomination();
  },
  mounted() {
    this.phone = this.userInfo.phone ? this.userInfo.phone : "";
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    returnFun() {
      //返回按钮
      let vm = this;
      vm.comboInfo = {};
      vm.tabNum = 0;
      vm.$emit("update:showReturn", false);
      if (vm.comboFlag) {
        vm.comboFlag = false;
        return;
      }
    },
    fieldFocus() {
      //修改号码
      let vm = this;
      vm.comboInfo = {};
      if (vm.phone == "") {
        vm.operatorName = "";
        vm.operatorId = 0;
        return;
      }
      let reg = /^0?[89]\d{9}$/;
      if (reg.test(vm.phone)) {
        vm.judgeOperator();
      } else {
        vm.operatorName = "";
        vm.operatorId = -1;
        vm.money = 0;
        vm.moneyId = 0;
        if (vm.rechargeType == 0) {
          vm.denomination = [];
          vm.operator_recharge = {};
          vm.recently = "0.00";
        }
      }
    },
    fieldInput() {
      //输入手机号
      let vm = this;
      vm.comboInfo = {};
      if (vm.phone == "") {
        vm.operatorName = "";
        vm.operatorId = 0;
        return;
      }
      let reg = /^0?[89]\d{9}$/; //判断号码是否是08/09（11位） 8/9（10位）
      if (reg.test(vm.phone)) {
        vm.judgeOperator();
      } else {
        vm.operatorName = "";
        vm.operatorId = -1;
        vm.money = 0;
        vm.moneyId = 0;
        if (vm.rechargeType == 0) {
          vm.denomination = [];
          vm.operator_recharge = {};
          vm.recently = "0.00";
        }
      }
    },
    getCurPay(data) {
      // 获取当前支付信息
      this.curPay = data;
    },
    clickCombo() {
      //选择套餐
      let vm = this;
      if (vm.phone == "") {
        vm.$toast(vm.$t("common.enterMobile"));
        return false;
      }
      if (vm.operatorId == -1) {
        vm.$toast(vm.$t("recharge.phoneNumberError"));
        return false;
      }
      if (vm.operatorName == "Smart" || vm.operatorName == "smart") {
        vm.selectComboFlag = true;
        return false;
      }
      vm.comboFlag = true;
      vm.$emit("update:showReturn", true);
    },
    selectCombo(flag) {
      // 选择运营商
      console.log("selectCombo", flag);
      this.selectComboFlag = false;
      if (flag == 1) {
        // Tnt
        this.operatorId = 4;
      }
      this.comboFlag = true;
      this.$emit("update:showReturn", true);
    },
    getComboInfo(data) {
      //获取套餐信息
      let vm = this;
      vm.comboInfo = data;
      vm.money = Number(data.amount);
      vm.comboFlag = false;
      vm.$emit("update:showReturn", false);
    },
    nextStep() {
      //充值第一步,先做判断
      let vm = this;
      if (vm.phone == "") {
        vm.$Message.info(vm.$t("common.enterMobile"));
        return false;
      }
      if (vm.operatorId == -1) {
        vm.$Message.info(vm.$t("recharge.phoneNumberError"));
        return false;
      }
      if (vm.rechargeType == 0 && !vm.denomination.length) {
        vm.$Message.info(vm.$t("recharge.operatorNotSupport"));
        return false;
      }
      if (vm.rechargeType == 1) {
        if (vm.operatorState[vm.operatorId] == 0) {
          vm.$Message.info(vm.$t("recharge.operatorNotSupport"));
          return false;
        }
        if (!vm.comboInfo.denomination_id) {
          //流量充值
          vm.$Message.info(vm.$t("recharge.pleaseSelectPackage"));
          return false;
        }
      }
      if (vm.rechargeType == 0) {
        //话费充值
        if (vm.money == "" || vm.money == 0) {
          //判断金额是否为空
          vm.$Message.info(vm.$t("common.enterAmount"));
          return false;
        }
        //判断金额是否在允许范围内
        if (
          !vm.moneyId &&
          vm.operator_recharge &&
          vm.operator_recharge.amount_mini
        ) {
          if (vm.money < Number(vm.operator_recharge.amount_mini)) {
            vm.$Message.info(
              vm.$t("common.customized") +
                vm.$t("common.amountCannotMin") +
                vm.operator_recharge.amount_mini
            );
            return;
          }
          if (vm.money > Number(vm.operator_recharge.amount_max)) {
            vm.$Message.info(
              vm.$t("common.customized") +
                vm.$t("common.amountCannotMax") +
                vm.operator_recharge.amount_max
            );
            return;
          }
        }
      }

      if (vm.curPay.payment_id == 3) {
        //余额充值
        if (vm.money > Number(vm.userInfo.money_usable)) {
          vm.$Message.info(vm.$t("recharge.insufficientBalanceChooseOtherPay"));
          return false;
        }
        vm.tabNum = 1;
        vm.$emit("update:showReturn", true);
      } else {
        //微信充值
        vm.paycalls();
      }
    },
    paycalls() {
      //立即充值
      let vm = this;
      let params = {};
      params.type = vm.rechargeType == 0 ? 5 : 6;
      params.phone = vm.phone;
      params.amount = vm.money;
      params.denomination_id =
        vm.rechargeType == 0 ? vm.moneyId : vm.comboInfo.denomination_id;
      params.pay_password = vm.payPsd;
      params.payment_id = vm.curPay.payment_id; //支付方式，3.余额、5.微信扫码支付
      vm.$post("/app/recharge/paycalls", params, {
        loading: true
      }).then(res => {
        console.log("paycalls", res);
        vm.payMentInfo = res;
        if (vm.curPay.payment_id == 3) {
          vm.tabNum = 2;
        }
        if (vm.curPay.payment_id == 5) {
          // 5.微信扫码支付
          vm.tabNum = 1;
          vm.$emit("update:showReturn", true);
        }
      });
    },
    getPayCode() {
      // 获取支付信息
      this.tabNum = 2;
    },
    getCalls() {
      // 获取充值信息
      let vm = this;
      let params = {};
      params.type = vm.rechargeType == 0 ? 5 : 6;
      vm.$post("/app/recharge/calls", params, { loading: true }).then(res => {
        console.log("calls", res);
        vm.callInfo = res;
        vm.historyList = res.record;
      });
    },
    operatorDataPackageState() {
      // 运营商支持流量套餐状态
      let vm = this;
      vm.$post(
        "/app/recharge/operatorDataPackageState",
        {},
        { loading: true }
      ).then(res => {
        console.log("operatorDataPackageState", res);
        vm.operatorState = res;
      });
    },
    getCallsDenomination() {
      // 话费充值面板
      let vm = this;
      vm.$post(
        "/app/recharge/callsDenomination",
        { type: 5 },
        { loading: true }
      ).then(res => {
        console.log("callsDenomination", res);
        vm.allMoney = res.list;
        vm.getFetchOperatorPre();
      });
    },
    getFetchOperatorPre() {
      //获取运营商字段
      let vm = this;
      vm.$post(
        "/app/index/fetchOperatorPre",
        {},
        {
          loading: true
        }
      ).then(res => {
        console.log("fetchOperatorPre", res);
        vm.operatorList = res.list;
        if (vm.phone != "") {
          vm.fieldInput(vm.phone);
        }
      });
    },
    judgeOperator() {
      //手机号码判断运营商
      let vm = this;
      for (let i = 0; i < vm.operatorList.length; i++) {
        if (vm.phone.indexOf(vm.operatorList[i].tel) == 0) {
          vm.operatorName = vm.operatorList[i].name;
          vm.operatorId = vm.operatorList[i].operator_id;
          console.log(vm.operatorName, vm.operatorId);
          if (vm.rechargeType == 0) {
            vm.denomination = vm.allMoney[vm.operatorId].denomination;
            vm.operator_recharge = vm.allMoney[vm.operatorId].operator_recharge;
            vm.recently = vm.allMoney[vm.operatorId].previous_record;
          }
          break;
        } else {
          vm.operatorName = "";
          vm.operatorId = -1;
          vm.money = 0;
          vm.moneyId = 0;
          if (vm.rechargeType == 0) {
            vm.denomination = [];
            vm.operator_recharge = {};
            vm.recently = "0.00";
          }
        }
      }
    }
  },
  watch: {
    rechargeType(num) {
      console.log("rechargeType", num);
      this.comboInfo = {};
    },
    userInfo() {
      this.phone = this.userInfo.phone;
    }
  }
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.first-step {
  padding: 20px 50px;
  dl {
    margin-bottom: 20px;
    dd {
      /deep/.custom-recently {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .choose-combo {
        width: 400px;
        height: 32px;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        padding: 4px 7px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        /deep/.ivu-icon {
          color: #dcdee2;
        }
        .info {
          width: 100%;
          color: #4a4a4a;
          font-size: 12px;
          display: flex;
          justify-content: space-between;
          overflow: hidden;
          &.default {
            color: #dcdee2;
          }
          p {
            flex: 1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      .money-wrap {
        display: flex;
        flex-wrap: wrap;
        margin-top: -10px;
        .money-item {
          cursor: pointer;
          margin-left: 15px;
          margin-top: 10px;
          padding: 5px 10px;
          text-align: center;
          min-width: 88px;
          height: 60px;
          color: #666;
          background: #fff;
          border: 1px solid #ccc;
          border-radius: 5px;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            color: #fff;
            border-color: #2043ac;
            background: linear-gradient(
              90deg,
              rgba(32, 67, 172, 1) 0%,
              rgba(19, 15, 115, 1) 100%
            );
          }
          &:hover {
            border-color: #2043ac;
          }
          img {
            vertical-align: middle;
            margin-right: 8px;
            width: 30px;
            height: 30px;
          }
        }
      }
      .tab-input {
        display: flex;
        align-items: center;
        height: 30px;
        line-height: 30px;
        margin-top: 10px;
        /deep/.ivu-input-wrapper,
        /deep/.ivu-input-number {
          width: 200px;
          margin-left: 10px;
          margin-right: 10px;
        }
        .marginR {
          margin-right: 10px;
        }
        p {
          font-size: 12px;
          cursor: pointer;
        }
      }
      .discounts {
        cursor: pointer;
        margin-bottom: 5px;
      }
      .pay-list {
        display: flex;
        flex-wrap: wrap;
        margin-top: -10px;
        .pay-item {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-right: 15px;
          margin-top: 10px;
          min-width: 160px;
          height: 40px;
          padding: 5px 10px;
          background: #fff;
          border: 1px solid #ccc;
          border-radius: 5px;
          transition: all 0.5s;
          &:hover {
            border-color: #2042ab;
          }
          &.active {
            position: relative;
            border-color: #2042ab;
            &:after {
              content: "";
              position: absolute;
              right: 0;
              bottom: 0;
              width: 25px;
              height: 20px;
              background: url("~@/assets/images/public/checked.png") no-repeat;
            }
          }
          img {
            margin-right: 8px;
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }
}

.sweep-code {
  text-align: center;
  h5 {
    color: #2042ab;
    font-size: 28px;
    padding: 10px;
  }
  .code {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    img {
      width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }
  p {
    font-size: 16px;
    color: #4a4a4a;
    padding: 10px;
  }
  .password {
    width: 300px;
    margin: 0 auto;
    .inputPsd {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #2042ab;
      border-radius: 5px;
      /deep/.ivu-input {
        border: 0;
        height: 46px;
        padding-right: 40px;
        line-height: 46px;
        font-size: 16px;
        color: #2042ab;
      }
      /deep/.ivu-input-suffix {
        cursor: pointer;
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        .ivu-icon {
          font-size: 22px;
          color: #2042ab;
        }
      }
    }
  }
}

.buttonWarp {
  width: 300px;
  margin: 0 auto;
  button {
    height: 45px;
    font-size: 20px;
  }
  p {
    font-size: 12px;
    color: #666;
    padding-top: 10px;
    text-align: center;
  }
}

.modal-title {
  h3 {
    text-align: center;
    font-size: 20px;
  }
}
.modal-container {
  p {
    font-size: 16px;
    color: #4a4a4a;
    line-height: 28px;
    margin-bottom: 20px;
  }
}
/deep/.vertical-center-modal .ivu-modal .ivu-modal-footer {
  padding: 0;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #dcdee2;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  overflow: hidden;
  /deep/.ivu-btn {
    flex: 1;
    height: 50px;
    margin: 0;
    border: 0;
    border-radius: 0;
    color: #2042ab;
  }
  /deep/.ivu-btn + .ivu-btn {
    border-left: 1px solid #dcdee2;
  }
}
</style>
